import * as service from "../service";
import type { ServiceResponse } from "../types";

export type GetBusinessDashboardStatsParams = {
  /** 4-digit year, e.g. "2025" — omit with `month` for lifetime totals */
  year?: string;
  /** 1-2 digit month, e.g. "9" — omit with `year` for lifetime totals */
  month?: string;
};

export type BusinessDashboardCouponStat = {
  coupon_id?: string;
  coupon_name?: string | null;
  coupon_image?: string | null;
  reads?: number;
  readers?: number;
  redeemed?: number;
  used?: number;
  [key: string]: any;
};

export type BusinessDashboardSponsorStat = {
  sponsor_id?: string;
  name?: string | null;
  image_url?: string | null;
  reads?: number;
  readers?: number;
  redeemed?: number;
  students?: number;
  [key: string]: any;
};

export type BusinessDashboardStatsSummary = {
  coupon_reads?: number;
  coupon_readers?: number;
  coupon_redeemed?: number;
  coupon_used?: number;
  sponsor_reads?: number;
  sponsor_readers?: number;
  sponsor_redeemed?: number;
  sponsor_students?: number;
  [key: string]: any;
};

export type BusinessDashboardStats = {
  year?: number | string;
  month?: number | string;
  range?: { start_unix?: number; end_unix?: number };
  summary?: BusinessDashboardStatsSummary;
  coupons?: BusinessDashboardCouponStat[];
  sponsors?: BusinessDashboardSponsorStat[];
};

/**
 * Fetch reach & engagement stats (reads / readers / redemptions) for the
 * currently logged-in business user. Pass `year` + `month` for one calendar
 * month, or `{}` for lifetime totals.
 * Backend: GET /api/business/dashboard/getStats
 */
export const GetBusinessDashboardStatsAPI = async (
  params: GetBusinessDashboardStatsParams,
): Promise<ServiceResponse<BusinessDashboardStats>> => {
  try {
    const resp = (await service.call(
      "GET",
      "api/business/dashboard/getStats",
      {
        ...(params.year ? { year: params.year } : {}),
        ...(params.month ? { month: params.month } : {}),
      },
    )) as ServiceResponse<BusinessDashboardStats>;
    return resp;
  } catch (err) {
    console.error(`GetBusinessDashboardStatsAPI ${err}`);
    return { status: -1, error: err };
  }
};
